import React from "react";
import { HEALTH_LABEL, healthFor, fmtScore } from "../../lib/ratings";
import "./Reviews.css";

// The score dial. A conic gradient conveys its value by colour and arc alone, so it
// carries an explicit label for anyone who cannot see either.
const ARC = {
  strong: "var(--v2-rating-green)",
  watch: "var(--v2-rating-yellow)",
  atrisk: "var(--v2-rating-red)",
  unscored: "var(--v2-rating-gray)",
};

const ScoreRing = ({ score, small }) => {
  const health = healthFor(score);
  return (
    <div
      className={`v2-ring${small ? " v2-ring--sm" : ""}`}
      style={{ "--score": score ?? 0, "--rc": ARC[health] }}
      role="img"
      aria-label={score === null || score === undefined
        ? "Not yet scored"
        : `Score ${score} out of 100, ${HEALTH_LABEL[health]}`}
    >
      <span>{fmtScore(score)}</span>
    </div>
  );
};

export default ScoreRing;
